require('@theme/cssnormalize-min.css');
var comcss = require('@theme/common.scss');
var toolcss = require('@theme/tools.scss');

var com = require('@common/common.js');
var cfg = require('@common/config.js');
var utils = require('@common/utils.js');

module.exports = {
    comcss: comcss,
    toolcss: toolcss,
    com: com,
    cfg: cfg,
    utils: utils,
    title: '订单农业云平台'
};






// WEBPACK FOOTER //
// ./component/res.js